import { RightFloatingButtonScalor } from "../../editor_common_components.js";
import { Button } from "../../../core/components/button.js";
import { General } from "../../../../siteManagement/general.js";
import { SheetEventType } from "../../../../siteManagement/sheet.js";
import { TypescriptCompiler, CompilationResult } from "../../ts_compiler_services.js";
import { Menu, EntryType } from "../../../core/components/menu.js";
import { ExtraLib, MonacoEditor, MonacoEditorDiffViewer, ReactEditor } from "../../../core/components/monacoEditor.js";
import { ErrorBoundary } from "../../components/error_boundary.js";
import { Helper } from "../../../core/util/helper.js";
import React from "react";
export class ReactComponentEditor extends React.Component<{ onTextChange: any, value: string, label: string, customProps: { extraLibs: ExtraLib[] } }, { showDialog: boolean }> {
    constructor(props) {
        super(props);
        this.state = { showDialog: false };
    }

    handleSave = (name) => {
        this.props.onTextChange(name);
    }

    openEditorSheet = () => {
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.SavedSuccessfully, (target) => {
        });

        const props: ScriptEditorProps = {
            value: this.props.value,
            extraLibs: this.props.customProps.extraLibs as ExtraLib[],
            onSave: this.handleSave,
            onClose: null
        };
        sheet.setTitle("Edit React component");
        sheet.show(() => {
            sheet.mountContent(ReactComponentEditorDialog, props);
        });
    }

    render() {
        return (
            <li>
                <div title={this.props.label}>
                    <span className="property-name">
                        <RightFloatingButtonScalor>
                            <Button iconName="edit" title="Edit" handleClick={this.openEditorSheet}></Button>
                        </RightFloatingButtonScalor>
                        {this.props.label}
                    </span>
                    <div className="c" style={{ "whiteSpace": "nowrap" }}>
                        Script
                    </div>
                </div>
            </li>
        );
    }
};

interface ScriptEditorProps {
    onSave,
    onClose,
    value,
    extraLibs?: ExtraLib[]
}

export class ReactComponentEditorDialog extends React.Component<ScriptEditorProps, { initializing: boolean, diagnostics: ts.Diagnostic[], monacoKey: string, transpiledComponent?: any, transpiledCode?: string }> {
    private code: string;
    private es5Code: string;
    private typescriptCompiler: TypescriptCompiler;

    constructor(props) {
        super(props)
        this.code = (this.props.value ? this.props.value.sourceCode : null) || this.props.value;
        this.state = { initializing: true, diagnostics: [], monacoKey: kendo.guid() };
    }

    handleSave = () => {
        const transpiledCode = this.typescriptCompiler.transpileTsxToEs6(this.code)
        this.props.onSave && this.props.onSave({ sourceCode: this.code, transpiledCode: transpiledCode });
        General.Sheet.Manager.getTopMostSheet().hide();
    }

    handleTextChangeOnBlur = (newValue) => {
        this.code = newValue;
    }

    handleTextChange = (newValue) => {
        this.code = newValue;
    }

    async componentDidMount() {
        this.typescriptCompiler = new TypescriptCompiler();
        await this.typescriptCompiler.Init();
        this.setState({ initializing: false });
    }

    handleCompileTypescript = async () => {
        const transpiledCode = this.typescriptCompiler.transpileTsxToEs6(this.code)
        this.es5Code = transpiledCode;
        try {
            const result = eval(transpiledCode);
            const newState: any = { transpiledCode: transpiledCode };
            if (transpiledCode != this.state.transpiledCode) {
                newState.transpiledComponent = result;
            }
            this.setState(newState);
        } catch (e) {
            this.setState({ transpiledComponent: null, transpiledCode: transpiledCode })
            console.log(e);
        }
    }

    render() {
        if (this.state.initializing) {
            return <div />
        }
        return (
            <>
                <div style={{ height: "100%", display: "flex" }}>
                    <Menu entries={[
                        { type: EntryType.Save, onClick: this.handleSave },
                        { text: "Compile", onClick: this.handleCompileTypescript },

                    ]} onSelect={() => {
                    }} enableMenuItem={() => true} handleEval={() => {
                    }} />
                    <ReactEditor
                        key={this.state.monacoKey}
                        language={"typescript"}
                        extraLibs={[]}
                        code={this.code}
                        onKeyPress={this.handleTextChange}
                        onTextChange={this.handleTextChangeOnBlur} />
                    <div style={{ width: "550px" }}>
                        <ErrorBoundary>
                            {this.state.transpiledComponent ? React.createElement(this.state.transpiledComponent, { data: [], context: {}, api: {} }) : null}
                        </ErrorBoundary>
                    </div>
                </div>
            </>
        );
    }
};
